import { render, staticRenderFns } from "./Solicitud.vue?vue&type=template&id=5635b0ae&scoped=true"
import script from "./Solicitud.vue?vue&type=script&lang=js"
export * from "./Solicitud.vue?vue&type=script&lang=js"
import style0 from "./Solicitud.vue?vue&type=style&index=0&id=5635b0ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5635b0ae",
  null
  
)

export default component.exports